import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("bqns_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err, fallback = "حدث خطأ ما، حاول مرة أخرى") {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return fallback;
}
